import type { PowerSyncDatabase, PowerSyncBackendConnector } from '@powersync/web';

/**
 * Retry Sync — non-destructive reconnect cycle.
 * Disconnects, waits briefly, then reconnects to trigger a fresh sync stream.
 */
export async function retrySync(
  db: PowerSyncDatabase,
  connector: PowerSyncBackendConnector,
): Promise<void> {
  console.log('[SyncActions] retrySync: disconnecting...');
  await db.disconnect();

  // Brief pause to let the server close the stream cleanly
  await new Promise((r) => setTimeout(r, 1_000));

  console.log('[SyncActions] retrySync: reconnecting...');
  await db.connect(connector);
  console.log('[SyncActions] retrySync: reconnected');
}

/**
 * Force Resync — destructive clear + reload (CrabTayo pattern).
 * Clears the local OPFS/IndexedDB database and hard-reloads the page.
 * The app will re-initialize and do a full sync from the server.
 */
export async function forceResync(db: PowerSyncDatabase): Promise<void> {
  console.log('[SyncActions] forceResync: clearing local database...');
  await db.disconnectAndClear({ clearLocal: true });
  console.log('[SyncActions] forceResync: reloading page...');
  window.location.reload();
}
